import {api} from '../utils'

export default {
    getAccount: () => api.get('/account'),
    changePassword: data => api.post('/account/password', data),
    updateAccount: data => api.put('/account', data),
    uploadAvatar: formData => api.post('/account/avatar', formData, {headers: {'Content-Type': 'multipart/form-data'}}),
    removeAvatar: () => api.delete('/account/avatar'),
    getOrganization: () => api.get('/organization/settings'),
    updateOrganization: data => api.put('/organization/settings', data),
    uploadOrganizationLogo: formData =>
        api.post('/organization/settings/logo', formData, {headers: {'Content-Type': 'multipart/form-data'}}),
    removeOrganizationLogo: () => api.delete('/organization/settings/logo'),
    getUsers: params => api.get('/users', {params}),
    getRoles: () => api.get('/roles'),
    inviteUser: data => api.post('/users/invite', data),
    updateUser: (id, data) => api.put(`/users/${id}`, data),
    cancelInvitation: id => api.delete(`/users/${id}/cancel-invitation`),
    resendInvitation: id => api.post(`/users/${id}/resend-invitation`),
    deactivateUser: (id, data) => api.post(`/users/${id}/deactivate`, data),
    reactivateUser: (id, data) => api.post(`/users/${id}/reactivate`, data),
    createRole: data => api.post('/roles', data),
    updateRole: (id, data) => api.put(`/roles/${id}`, data),
    deleteRole: id => api.delete(`/roles/${id}`),
    moveAndRemoveRole: (id, data) => api.post(`/roles/${id}/reassign-members`, data),
    getRole: id => api.get(`/roles/${id}`),
    welcomeAcknowledge: () => api.post('/account/welcome/acknowledge'),
    assignRoleToUser: (id, data) => api.post(`/users/${id}/roles`, data),
    removeRoleFromUser: (userId, roleId) => api.delete(`/users/${userId}/roles/${roleId}`),
    setUserRole: (id, data) => api.put(`/users/${id}/role`, data),
    getBranches: () => api.get('/branches'),
    updatePayerCredentials: (id, data) => api.put(`/branch-payers/credentials/${id}`, data),
}
